import { FormattedMessage } from 'react-intl';
const UnlimitedSpaces = () => {
	return (
		<div>
			<p>
				<FormattedMessage
					id="ConfluencePricingPageTeam24.features.unlimitedSpaces.content.body"
					defaultMessage="Spaces are how you organize pages into meaningful categories, like different folders where you can store your work. You can create as many spaces as you need."
				/>
			</p>
		</div>
	);
};
export default UnlimitedSpaces;
